import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=4a799f5a&scoped=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts"
export * from "./CalendarView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a799f5a",
  null
  
)

export default component.exports